/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */

//-----------------------------------------------------------------------------------------------------------
// DO NOT EDIT, this is an Auto-generated file from scripts/semconv/templates/registry/ts-stable/events.ts.j2
//-----------------------------------------------------------------------------------------------------------

/**
 * This event describes a single exception.
 */
export const EVENT_EXCEPTION = 'exception' as const;

